import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

// Import slices
import candidatesSlice from './slices/candidatesSlice';
import jdsSlice from './slices/jdsSlice';
import uiSlice from './slices/uiSlice';
import authSlice from './slices/authSlice';
import adminUserSlice from './slices/adminUserSlice';

import evaluationSlice from './slices/evaluationSlice';
import screeningSlice from './slices/screeningSlice';
import clientSlice from './slices/clientSlice';
import themeSlice from './slices/themeSlice';
import interviewSlice from './slices/interviewSlice';
import linkedinProfilesSlice from './slices/linkedinProfilesSlice';

// Root reducer
const rootReducer = combineReducers({
  candidates: candidatesSlice,
  jds: jdsSlice,
  ui: uiSlice,
  auth: authSlice,
  adminUser: adminUserSlice,
  evaluation: evaluationSlice,
  screening: screeningSlice,
  client: clientSlice,
  theme: themeSlice,
  interview: interviewSlice,
  linkedinProfiles: linkedinProfilesSlice,
});

// Persist configuration
const persistConfig = {
  key: 'hyrex-root',
  storage,
  whitelist: ['ui', 'evaluation', 'screening', 'candidates', 'theme', 'jds', 'interview', 'auth', 'client', 'adminUser', 'linkedinProfiles'], // Persist ui, evaluation, screening, candidates, theme, and interview state (auth now uses cookies)
  blacklist: [], // Don't persist auth data (auth uses cookies)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Create persistor
export const persistor = persistStore(store);



// Export other Redux modules
export * from './hooks';
export * from './actions';

// Export slices for direct access if needed
export { default as authSlice } from './slices/authSlice';
export { default as adminUserSlice } from './slices/adminUserSlice';

export { default as candidatesSlice } from './slices/candidatesSlice';
export { default as jdsSlice } from './slices/jdsSlice';
export { default as uiSlice } from './slices/uiSlice';
export { default as evaluationSlice } from './slices/evaluationSlice';
export { default as screeningSlice } from './slices/screeningSlice';
export { default as clientSlice } from './slices/clientSlice';
export { default as themeSlice } from './slices/themeSlice';
export { default as interviewSlice } from './slices/interviewSlice';
export { default as linkedinProfilesSlice } from './slices/linkedinProfilesSlice';

export default store;



















